import api from "../base";
import { Routes } from "./routes";
import { AxiosResponse } from "axios";

/**
 * Retrieve options
 */
export const getOptions = (): Promise<AxiosResponse<unknown>> => api.get(Routes.OPTIONS);
